import React, { useState } from "react";
import styles from "./lucas_msalomao.module.scss";
import logoImg from "./src/logo.png";
import whatsappImg from "./src/whatsapp.png";
import siteImg from "./src/site.png";
import mapsImg from "./src/maps.png";
import instagramImg from "./src/instagram.png";
import servicosImg from "./src/servicos.png";
import fixoImg from "./src/fixo.png";
import { Link } from "react-router-dom";

const Lucas_msalomao: React.FC = () => {
    const [showModal, setShowModal] = useState(false);
    const items = [
        { img: whatsappImg, text: "FALE COMIGO", borderLeft: true, borderRight: false, link: "https://wa.me/5517981453464?text=Olá! Vim pelo seu cartão digital e gostaria de mais informações...", router: false },
        { img: mapsImg, text: "LOCALIZAÇÃO", borderLeft: true, borderRight: false, link: "https://maps.app.goo.gl/ZsHhCChuiD5pWZQFA", router: false },
        { img: siteImg, text: "SITE", borderLeft: true, borderRight: true, link: "", router: false },
        { img: fixoImg, text: "ESCRITÓRIO", borderLeft: true, borderRight: false, link: "tel:1733243377", router: false },
        { img: instagramImg, text: "INSTAGRAM", borderLeft: true, borderRight: false, link: "https://www.instagram.com/lucas.msalomao?igsh=MWRrMG45MnB2ZjE1bA%3D%3D&utm_source=qr", router: false },
        { img: servicosImg, text: "SERVIÇOS", borderLeft: true, borderRight: true, link: "/lucas_msalomao/servicos", router: true },
    ];

    return (
        <div className={styles.lucas_msalomao}>
            <div className={styles.container}>
                <div className={styles.header}>
                    <img src={logoImg} alt="Logo Adamo & Salomão" className={styles.logo} />
                </div>
                <div className={styles.body}>
                    <div className={styles.grid}>
                        {items.map((item, index) => {
                            // Se for o item SITE, renderizar com onClick para abrir modal
                            if (item.text === "SITE") {
                                return (item.borderLeft && item.borderRight) ?
                                    <div key={index} className={styles.card} style={{ borderLeft: "1px solid #DE8043", borderRight: "1px solid #DE8043", cursor: "pointer" }} onClick={() => setShowModal(true)}>
                                        <img src={item.img} alt={item.text} />
                                        <p>{item.text}</p>
                                    </div>
                                    : null;
                            }

                            // Renderização normal para outros itens
                            return item.router ?
                                (item.borderLeft && item.borderRight) ?
                                    <Link to={item.link} key={index}>
                                        <div className={styles.card} style={{ borderLeft: "1px solid #DE8043", borderRight: "1px solid #DE8043" }}>
                                            <img src={item.img} alt={item.text} />
                                            <p>{item.text}</p>
                                        </div>
                                    </Link>
                                    :
                                    item.borderLeft ?
                                        <Link to={item.link} key={index}>
                                            <div className={styles.card} style={{ borderLeft: "1px solid #DE8043" }}>
                                                <img src={item.img} alt={item.text} />
                                                <p>{item.text}</p>
                                            </div>
                                        </Link>
                                        :
                                        item.borderRight ?
                                            <Link to={item.link} key={index}>
                                                <div className={styles.card} style={{ borderRight: "1px solid #DE8043" }}>
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </Link>
                                            :
                                            <Link to={item.link} key={index}>
                                                <div className={styles.card} >
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </Link>
                                :
                                (item.borderLeft && item.borderRight) ?
                                    <a href={item.link} target="_blank" rel="noopener noreferrer" key={index}>
                                        <div className={styles.card} style={{ borderLeft: "1px solid #DE8043", borderRight: "1px solid #DE8043" }}>
                                            <img src={item.img} alt={item.text} />
                                            <p>{item.text}</p>
                                        </div>
                                    </a>
                                    :
                                    item.borderLeft ?
                                        <a href={item.link} target="_blank" rel="noopener noreferrer" key={index}>
                                            <div className={styles.card} style={{ borderLeft: "1px solid #DE8043" }}>
                                                <img src={item.img} alt={item.text} />
                                                <p>{item.text}</p>
                                            </div>
                                        </a>
                                        :
                                        item.borderRight ?
                                            <a href={item.link} target="_blank" rel="noopener noreferrer" key={index}>
                                                <div className={styles.card} style={{ borderRight: "1px solid #DE8043" }}>
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </a>
                                            :
                                            <a href={item.link} target="_blank" rel="noopener noreferrer" key={index}>
                                                <div className={styles.card} >
                                                    <img src={item.img} alt={item.text} />
                                                    <p>{item.text}</p>
                                                </div>
                                            </a>
                        })}
                    </div>
                </div>
            </div>

            {/* Modal Em Construção */}
            {showModal && (
                <div className={styles.modalOverlay} onClick={() => setShowModal(false)}>
                    <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                        <button className={styles.modalCloseX} onClick={() => setShowModal(false)}>×</button>
                        <p className={styles.modalText}>
                            Nosso site está em construção. Em breve, você terá acesso a todas as informações sobre nossos serviços jurídicos.
                        </p>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Lucas_msalomao;

